import { render, staticRenderFns } from "./apps.vue?vue&type=template&id=2bfdcd8d&scoped=true"
import script from "./apps.vue?vue&type=script&lang=js"
export * from "./apps.vue?vue&type=script&lang=js"
import style0 from "./apps.vue?vue&type=style&index=0&id=2bfdcd8d&prod&scoped=true&lang=css"
import style1 from "./apps.vue?vue&type=style&index=1&id=2bfdcd8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bfdcd8d",
  null
  
)

export default component.exports